export default __webpack_public_path__ + "static/media/widget_yellow.93bb6519.svg";